var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 16C31 24.3 24.3 31 16 31C7.7 31 1 24.3 1 16C1 7.7 7.7 1 16 1C24.3 1 31 7.7 31 16Z",
    fill: "#FDE047"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8998 6.60001C30.6498 5.25001 29.8998 4.15001 28.6498 3.80001C27.2998 3.45001 26.0998 3.95001 24.9498 5.15001C24.2998 3.35001 23.2998 2.00001 21.6998 1.30001C20.0998 0.600014 18.4998 1.10001 17.4998 2.35001C16.4498 3.65001 16.0498 5.70001 17.1498 8.35001C18.1998 10.85 22.8498 15.85 22.9998 16C23.1998 15.9 28.3998 12.65 29.6498 11.05C30.8998 9.50001 31.1498 7.95001 30.8998 6.60001ZM14.4998 2.35001C13.4998 1.10001 11.8998 0.600014 10.2998 1.30001C8.69977 2.00001 7.69977 3.35001 7.04977 5.15001C5.84977 4.00001 4.64977 3.45001 3.29977 3.85001C2.09977 4.20001 1.29977 5.30001 1.04977 6.65001C0.799771 7.95001 1.09977 9.55001 2.29977 11.1C3.59977 12.65 8.79977 15.9 8.99977 16C9.14977 15.85 13.7998 10.85 14.8498 8.35001C15.9498 5.70001 15.5498 3.70001 14.4998 2.35001Z",
    fill: "#E31B54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 19.05C24.5 18.65 24.25 18.15 23.6 18C21.85 17.65 19.3 17.35 16 17.35C12.7 17.35 10.15 17.7 8.4 18C7.7 18.15 7.5 18.65 7.5 19.05C7.5 22.7 10.3 26.35 16 26.35C21.7 26.3 24.5 22.65 24.5 19.05Z",
    fill: "#664E27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3502 19.15C21.2502 18.95 18.9502 18.65 16.0002 18.65C13.0502 18.65 10.7502 18.95 9.65022 19.15C9.00022 19.25 8.95022 19.5 9.00022 19.9C9.05022 20.1 9.05022 20.4 9.15022 20.7C9.20022 21 9.30022 21.15 9.80022 21.1C10.7502 21 21.3002 21 22.2502 21.1C22.7502 21.15 22.8002 21 22.9002 20.7C22.9502 20.4 23.0002 20.15 23.0502 19.9C23.0502 19.5 23.0002 19.25 22.3502 19.15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji5);
export default __webpack_public_path__ + "static/media/emoji_5.6665b45d94eb03a3996d90e668c12d31.svg";
export { ForwardRef as ReactComponent };